import React from 'react';
import classNames from 'classnames';

export default function IntegrationContentContainer({
  children,
  className,
  ...rest
}: { className?: string } & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) {
  return (
    <div
      className={classNames(
        'mb-4 grid grid-cols-1 justify-items-start gap-4 rounded-lg border border-grey-300 bg-white p-6',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
